import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/About.css';
import magazineBanner from '../assets/magazine_banner.jpg';

function About() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-section" ref={sectionRef}>
      <div className="about-container">
        <div className={`about-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">{t('about.title')}</h2>
          <p className="section-subtitle">{t('about.subtitle')}</p>
        </div>

        <div className="about-content">
          <div className={`about-text ${isVisible ? 'visible' : ''}`}>
            <p className="about-story">
              {t('about.story')}
            </p>
            
            <blockquote className="about-quote">
              <span className="quote-mark">"</span>
              {t('about.quote')}
              <footer className="quote-author">{t('about.quoteAuthor')}</footer>
            </blockquote>

            <div className="about-stats">
              <div className="stat-card">
                <div className="stat-icon">🎂</div>
                <div className="stat-info">
                  <span className="stat-title">{t('about.experience')}</span>
                  <span className="stat-desc">{t('about.experienceDesc')}</span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">💝</div>
                <div className="stat-info">
                  <span className="stat-title">{t('about.quality')}</span>
                  <span className="stat-desc">{t('about.qualityDesc')}</span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">🌟</div>
                <div className="stat-info">
                  <span className="stat-title">{t('about.viral')}</span>
                  <span className="stat-desc">{t('about.viralDesc')}</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`about-image ${isVisible ? 'visible' : ''}`}>
            <div className="image-frame">
              <img 
                src={magazineBanner} 
                alt={t('about.magazineAlt')}
                className="magazine-image"
              />
              <div className="image-decoration"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Decorations */}
      <div className="about-bg-decoration about-deco-1"></div>
      <div className="about-bg-decoration about-deco-2"></div>
    </div>
  );
}

export default About;
